<template>
    <BreadCrumb PageTitle="Liste des Reglements Groupés" />
    <ListeReglementGroupe />
</template>

<script lang="ts">
    import { defineComponent } from "vue";

    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeReglementGroupe from "../../components/Reglement/ListeReglementGroupe.vue";

    export default defineComponent({
        name: "ListeReglementGroupePage",
        components: {
            BreadCrumb,
            ListeReglementGroupe,
        },
    });
</script>